// extracted by mini-css-extract-plugin
export default {"item":"DropdownItem-module--item--2Dyei","icon":"DropdownItem-module--icon--oSDca","right":"DropdownItem-module--right--f5GKP"};